import React from 'react';

/***** ATTENTION *****/
/* When changing anything here, please also update the ModalPortal in .storybook/preview-body.html */

export const MODAL_PORTAL_ID = 'modal-root';

export const ModalPortal = () => {
  return <div id={MODAL_PORTAL_ID} className="fixed z-modal pointer-events-none top-0 left-0 w-full h-full" />;
};
